import styled, { css } from 'styled-components';

import { spacer, unit, pixelate, margin, SIZE, mediaQuery, maxWidth } from './metrics'

export const typeHeading01 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: ${props => props.theme.cyrillic ? '26px' : '44px'};
	line-height: 1.2;
	margin-left: -0.1rem;

	${mediaQuery[SIZE.medium]}{
		font-size: ${props => props.theme.cyrillic ? '36px' : '54px'};
	}

	${mediaQuery[SIZE.large]}{
		font-size: ${props => props.theme.cyrillic ? '38px' : '62px'};
	}

	${mediaQuery[SIZE.xlarge]}{
		font-size: ${props => props.theme.cyrillic ? '50px' : '72px'};
	}
`;

export const typeHeading02 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: ${props => props.theme.cyrillic ? '26px' : '36px'};
	line-height: 1.1;
	margin-left: -0.1rem;

	${mediaQuery[SIZE.large]}{
		font-size: ${props => props.theme.cyrillic ? '34px' : '44px'};

	}
`;

export const typeHeading03 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: ${props => props.theme.cyrillic ? '24px' : '32px'};
	line-height: 1.3;
	margin-left: -0.1rem;

	${mediaQuery[SIZE.large]}{
		font-size: ${props => props.theme.cyrillic ? '38px' : '48px'};
	}
`;

export const typeHeading04 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: 20px;
	line-height: 1.3;
	margin-left: -0.1rem;

	${mediaQuery[SIZE.large]}{
		font-size: 24px;
	}
`;

export const typeHeading05 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: 16px;
	line-height: 1.3;
	margin-left: -0.1rem;
`;

export const typeBody01 = css`
	font-family: 'Montserrat-Regular', sans-serif;
	font-size: 18px;
	line-height: 1.5;

	${mediaQuery[SIZE.large]}{
		font-size: 24px;
	}
`;

export const typeBody01_bold = css`
	${typeBody01}
	font-family: 'Montserrat-Bold', sans-serif;
`;

export const typeBody02 = css`
	font-family: 'Montserrat-Regular', sans-serif;
	line-height: 1.5;

	${mediaQuery[SIZE.large]}{
		font-size: 16px;
	}
`;

export const typeBody02_bold = css`
	${typeBody02}
	font-family: 'Montserrat-Bold', sans-serif;
`;

export const typeBody03 = css`
	font-family: 'Montserrat-Regular', sans-serif;
	font-size: 13px;
	line-height: 1.5;
`;

export const typeBody03_bold = css`
	${typeBody03}
	font-family: 'Montserrat-Bold', sans-serif;
`;

export const typeLabel01 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Bold' : 'BwGradual-Bold'}, sans-serif;
	font-size: 10px;
	letter-spacing: 0.05em;
	text-transform: uppercase;

	${mediaQuery[SIZE.large]}{
		font-size: 12px;
	}
`;

export const typeLabel02 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Regular' : 'BwGradual-Regular'}, sans-serif;
	font-size: 12px;
	letter-spacing: 0.05em;
`;

export const typeLabel03 = css`
	font-family: ${props => props.theme.cyrillic ? 'Montserrat-Bold' : 'BwGradual-Bold'},, sans-serif;
	font-size: 12px;
	letter-spacing: 0.05em;
	text-transform: uppercase;
`;